// URL del Worker de cotización independiente (Cloudflare). Ver external/cloudflare-worker/quote-worker.js
// Vacío = desactivado. Ejemplo: "https://bhgc-quote.tu-cuenta.workers.dev"
export const QUOTE_WORKER_URL = "https://bhgc-quote.apphs2024.workers.dev/";

// Cotiza vía Worker externo (sin Base44). Devuelve [] si no está configurado o falla.
export async function quoteViaWorker(payload) {
  if (!QUOTE_WORKER_URL) return [];
  try {
    const res = await fetch(QUOTE_WORKER_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...payload, only: Array.isArray(payload?.only) && payload.only.length ? payload.only : ["envia", "srsimi", "elogicya", "pak2go", "interpack", "skypractico", "slenvios", "sigomx", "enviot2", "genienvios"] })
    });
    if (!res.ok) return [];
    const data = await res.json().catch(() => ({}));
    return Array.isArray(data?.rates) ? data.rates : [];
  } catch {
    return [];
  }
}